module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/bg-8-0371e0eed7b506e0f2cfab3d562a0412.jpg";